export class OddChangeError extends Error {

    constructor(public readonly notice: any) {
        super(notice);
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(this, new.target.prototype);
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/errors/tickets/OddChangeError.ts